import { lazy } from "react";
import { PATHS } from "@/lib/router";

const CompanyListPage = lazy(() => import("./pages/CompanyListPage"));
const CompanySetupPage = lazy(() => import("./pages/CompanySetupPage"));

export const companyRoutes = [
  {
    path: PATHS.COMPANY_LIST,
    element: <CompanyListPage />,
    handle: { allowedRoles: ["system_admin"] },
  },
  {
    path: PATHS.COMPANY_SETUP,
    element: <CompanySetupPage />,
    // handle: {
    //   permission: {
    //     required: [
    //       "company_information:view",
    //       "company_information:create",
    //       "company_information:update",
    //     ],
    //     mode: "any",
    //   },
    // },
  },
];
